import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import MenuCard from "./MenuCard";
import "../../css/MenuManagement.css";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";

const MenuManagement = () => {
  const { user } = useSelector((state) => state.auth);

  const cleanString = (val) => {
    if (!val) return "";
    let s = String(val).trim();
    if (
      (s.startsWith('"') && s.endsWith('"')) ||
      (s.startsWith("'") && s.endsWith("'"))
    ) {
      s = s.slice(1, -1);
    }
    return s.trim();
  };

  const rawSessionUsername = sessionStorage.getItem("username");
  const rawSessionUserRole = sessionStorage.getItem("userRole");
  const loggedInUserName = cleanString(user?.data?.username || rawSessionUsername);
  const loggedInUserRole = cleanString(user?.data?.userRole || rawSessionUserRole);
  const loggedInRoleName = cleanString(user?.data?.roleName || "");
  const loggedInUserId = cleanString(user?.data?.userId || loggedInUserName);

  const isAuthorizedAdmin = () => {
    const role = loggedInUserRole.toUpperCase();
    const roleName = loggedInRoleName.toUpperCase();
    return (
      role === "ADMK" ||
      role === "ADCH" ||
      role === "ADMIN MAKER" ||
      role === "ADMIN CHECKER" ||
      roleName === "ADMIN MAKER" ||
      roleName === "ADMIN CHECKER"
    );
  };

  const [activeController, setActiveController] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [userName, setUserName] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [userMenuData, setUserMenuData] = useState("");
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isLoadingUserName, setIsLoadingUserName] = useState(false);
  const [errorMessageName, setErrorMessageName] = useState("");
  const [booleanArray, setBooleanArray] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (selectedLevel === "User" && selectedProfile) {
      handleUserID();
    } else if (selectedLevel === "Role") {
      handleRole();
    }
  }, [selectedLevel, selectedProfile]); // Trigger on changes to selectedLevel or selectedProfile

  const toggleController = (controller) => {
    setActiveController(activeController === controller ? null : controller);
  };

  const fetchMenuManagementData = async () => {
    if (selectedLevel === "User") {
      try {
        const requestBody = {
          username: loggedInUserName,
          userId: selectedUser,
          userProfile: selectedProfile,
        };

        const response = await axiosPostApi(
          apiList.FETCH_USER_MENU,
          requestBody
        );
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          const data = response?.data?.data?.userMenu;
          setUserMenuData(data);
          const booleanArray = data.split("").map((char) => char === "1");
          setBooleanArray(booleanArray);

          console.log("Menu length:", booleanArray.length);

          console.log("Charge Master bits:", booleanArray.slice(95, 100));

          if (data?.length === 0) {
            setNoData(true);
          } else {
            setNoData(false);
          }
        } else {
          setNoData(true);
          setUserMenuData([]);
          if (
            response?.data?.respCode !== "01" &&
            response?.data?.data !== null
          ) {
            CustomAlert({
              title: "Failed to Fetch Data",
              text:
                response?.data?.message ||
                "No data available for the specified criteria.",
              icon: "error",
              confirmButtonText: "Retry",
            });
          }
        }
      } catch (error) {
        CustomAlert({
          title: "Error",
          text: "An error occurred while fetching the data. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const requestBody = {
          username: loggedInUserName,
          userId: "",
          userProfile: selectedProfile,
          userRole: selectedUser,
        };

        const response = await axiosPostApi(
          apiList.MENU_FETCH_ROLE_MENU,
          requestBody
        );
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          const data = response?.data?.data?.menuList;
          setUserMenuData(data);
          const booleanArray = data.split("").map((char) => char === "1");
          setBooleanArray(booleanArray);
          if (data?.length === 0) {
            setNoData(true);
          } else {
            setNoData(false);
          }
        } else {
          setNoData(true);
          setUserMenuData([]);
          if (
            response?.data?.respCode !== "01" &&
            response?.data?.data !== null
          ) {
            CustomAlert({
              title: "Failed to Fetch Data",
              text:
                response?.data?.message ||
                "No data available for the specified criteria.",
              icon: "error",
              confirmButtonText: "Retry",
            });
          }
        }
      } catch (error) {
        CustomAlert({
          title: "Error",
          text: "An error occurred while fetching the data. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleProfileChange = (event) => {
    const value = event.target.value;
    setSelectedProfile(value);
    setUserName([]);
    setSelectedUser("");
  };

  const handleLevelChange = (event) => {
    const value = event.target.value;
    setSelectedLevel(value);
    setUserName([]);
    setSelectedUser("");
  };

  const handleUserID = () => {
    if (selectedLevel !== "User" || !selectedProfile) {
      return; // Ensure correct level and profile
    }
    setIsLoadingUserName(true);
    const requestBody = {
      username: loggedInUserName,
      userId: "",
      userProfile: selectedProfile,
      status: "1",
    };

    axiosPostApi(
      `${apiList.FETCH_USER_DATA}?pageSize=${pageSize}&pageNo=${currentPage}`,
      requestBody
    )
      .then((response) => {
        if (response?.status === 200 && response?.data?.data) {
          const rawUsers = response?.data?.data || [];
          // Restrict self: filter out logged-in user so they cannot edit permissions for themselves
          const filteredUsers = rawUsers.filter((item) => {
            const itemUserId = cleanString(item?.userId).toUpperCase();
            const itemUsername = cleanString(item?.username).toUpperCase();
            const currentUserId = loggedInUserId.toUpperCase();
            const currentUsername = loggedInUserName.toUpperCase();
            return (
              itemUserId !== currentUserId &&
              itemUserId !== currentUsername &&
              itemUsername !== currentUsername &&
              itemUsername !== currentUserId
            );
          });
          setUserName(filteredUsers);
          setIsLoadingUserName(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setIsLoadingUserName(false);
      });
  };

  const handleRole = () => {
    if (!selectedProfile) return;
    setIsLoadingUserName(true);
    const requestBody = {
      username: loggedInUserName,
      userProfile: selectedProfile,
    };

    axiosPostApi(apiList.MENU_USERROLE_DATA, requestBody)
      .then((response) => {
        if (
          response?.status === 200 &&
          response?.data?.data?.userRolesWithNames
        ) {
          const rawRoles = response.data.data.userRolesWithNames || [];
          // Restrict self: filter out logged-in user's role so they cannot edit permissions for their own role
          const filteredRoles = rawRoles.filter((role) => {
            const roleCode = cleanString(role?.userRole).toUpperCase();
            const roleName = cleanString(role?.roleName).toUpperCase();
            const currentUserRole = loggedInUserRole.toUpperCase();
            const currentRoleName = loggedInRoleName.toUpperCase();
            return (
              roleCode !== currentUserRole &&
              roleName !== currentRoleName &&
              roleCode !== currentRoleName &&
              roleName !== currentUserRole
            );
          });
          const roles = filteredRoles.map((role) => ({
            userId: role.userRole,
            name: role.roleName,
          }));
          setUserName(roles); // Set roles as user list
          setIsLoadingUserName(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setIsLoadingUserName(false);
      });
  };

  const handleDropdownChange = (event) => {
    setSelectedUser(event.target.value);
  };

  const handleSearchMenu = () => {
    if (selectedLevel === "User") {
      const targetUser = cleanString(selectedUser).toUpperCase();
      if (
        targetUser &&
        (targetUser === loggedInUserName.toUpperCase() ||
          targetUser === loggedInUserId.toUpperCase())
      ) {
        CustomAlert({
          title: "Restriction",
          text: "You cannot assign or view permissions for your own user account.",
          icon: "warning",
          confirmButtonText: "Okay",
        });
        return;
      }
    } else if (selectedLevel === "Role") {
      const targetRole = cleanString(selectedUser).toUpperCase();
      if (
        targetRole &&
        (targetRole === loggedInUserRole.toUpperCase() ||
          targetRole === loggedInRoleName.toUpperCase())
      ) {
        CustomAlert({
          title: "Restriction",
          text: "You cannot assign or view permissions for your own role.",
          icon: "warning",
          confirmButtonText: "Okay",
        });
        return;
      }
    }

    if (selectedProfile && (selectedUser || selectedLevel)) {
      fetchMenuManagementData();
    }
  };

  const handleToggle = (baseIndex, toggleIndex) => {
    if (!isAuthorizedAdmin()) {
      CustomAlert({
        title: "Permission Denied",
        text: "Only Admin Maker and Admin Checker are permitted to modify user permissions.",
        icon: "warning",
        confirmButtonText: "Okay",
      });
      return;
    }
    // Combine the baseIndex with the toggleIndex to get the actual index in booleanArray
    const actualIndex = baseIndex + toggleIndex;
    // Create a copy of the booleanArray
    const updatedArray = [...booleanArray];

    // Toggle the value at the correct index
    updatedArray[actualIndex] = !updatedArray[actualIndex];

    // Update the state with the new booleanArray
    setBooleanArray(updatedArray);
  };

  const modifyMenuManagementData = async () => {
    if (!isAuthorizedAdmin()) {
      CustomAlert({
        title: "Permission Denied",
        text: "Only Admin Maker and Admin Checker are permitted to grant or modify user permissions.",
        icon: "error",
        confirmButtonText: "Okay",
      });
      return;
    }

    if (selectedLevel === "User") {
      const targetUser = cleanString(selectedUser).toUpperCase();
      if (
        targetUser &&
        (targetUser === loggedInUserName.toUpperCase() ||
          targetUser === loggedInUserId.toUpperCase())
      ) {
        CustomAlert({
          title: "Restriction",
          text: "You cannot modify permissions for your own user account.",
          icon: "warning",
          confirmButtonText: "Okay",
        });
        return;
      }
    } else if (selectedLevel === "Role") {
      const targetRole = cleanString(selectedUser).toUpperCase();
      if (
        targetRole &&
        (targetRole === loggedInUserRole.toUpperCase() ||
          targetRole === loggedInRoleName.toUpperCase())
      ) {
        CustomAlert({
          title: "Restriction",
          text: "You cannot modify permissions for your own role.",
          icon: "warning",
          confirmButtonText: "Okay",
        });
        return;
      }
    }

    let updatedMenuArray = userMenuData.split("");
    booleanArray.forEach((currentValue, index) => {
      const originalValue = userMenuData[index]; // '0' or '1' from the original data

      // If there's a mismatch, modify the value in the array
      if (
        (currentValue && originalValue === "0") ||
        (!currentValue && originalValue === "1")
      ) {
        updatedMenuArray[index] = currentValue ? "1" : "0"; // Update the value at the specific index
      }
    });

    const updatedMenuString = updatedMenuArray.join("");
    try {
      const requestBody = {
        username: loggedInUserName,
        userId: selectedLevel === "User" ? selectedUser : "",
        userProfile: selectedProfile,
        userMenu: updatedMenuString,
        userRole: selectedLevel === "Role" ? selectedUser : "",
      };

      const response = await axiosPostApi(
        apiList.UPDATE_USER_MENU,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: "Success",
          text: "Menu updated successfully!",
          icon: "success",
          confirmButtonText: "Okay",
        });
        // Reset state after successful API call
        setSelectedProfile(""); // Reset profile selection
        setSelectedLevel(""); // Reset level selection
        setSelectedUser(""); // Reset user/role selection
        setUserMenuData(null); // Clear menu data
        setBooleanArray(new Array(booleanArray.length).fill(false)); // Reset toggles to all 'false'
        setActiveController(""); // Reset active controller, if applicable
        setErrorMessageName(""); // Clear any error message
        setUserName([]); // Clear user dropdown options
      } else {
        CustomAlert({
          title: "Failed to Update Data",
          text:
            response?.data?.message ||
            "An error occurred while updating the menu.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while updating the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  return (
    <div className="menu-management">
      {!isAuthorizedAdmin() && (
        <div
          style={{
            backgroundColor: "#FFF3CD",
            color: "#856404",
            padding: "12px 20px",
            borderRadius: "8px",
            border: "1px solid #FFEEBA",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          <i className="fa fa-exclamation-triangle" style={{ fontSize: "16px" }}></i>
          <span>
            <strong>Read-Only Notice:</strong> Only <strong>Admin Maker</strong> and <strong>Admin Checker</strong> have authorization to grant or modify permissions for other users.
          </span>
        </div>
      )}
      <section className="edit-user-section">
        <h2 className="menu-management-section-header">Edit User Permission</h2>
        <div className="edit-user-permission-container">
          <div className="user-dropdown-division">
            <label htmlFor="userProfileDropdown">User Profile</label>
            <select
              className="menu-select"
              id="userProfileDropdown"
              value={selectedProfile}
              onChange={handleProfileChange}
            >
              <option value="" disabled>
                Select Profile
              </option>
              <option value="OPERATION">OPERATION</option>
              <option value="FRANCHISE">Franchise</option>
              <option value="CUSTOMER">LMBP</option>
              <option value="HUB">HUB</option>
            </select>
          </div>

          <div className="user-dropdown-division">
            <label htmlFor="userLevelDropdown">User Level</label>
            <select
              className="menu-select"
              id="userLevelDropdown"
              value={selectedLevel}
              onChange={handleLevelChange}
              style={{ cursor: !selectedProfile ? "not-allowed" : "pointer" }}
              disabled={!selectedProfile}
            >
              <option value="" disabled>
                Select Level
              </option>
              <option value="Role">Role</option>
              <option value="User">User</option>
            </select>
          </div>

          <div className="user-dropdown-division">
            <label htmlFor="userNameDropdown">Name List</label>
            <div className="dropdown-with-error">
              <select
                className="menu-select"
                id="userNameDropdown"
                style={{ cursor: !selectedLevel ? "not-allowed" : "pointer" }}
                onChange={handleDropdownChange}
                value={selectedUser}
                disabled={!selectedLevel}
              >
                <option value="" disabled>
                  {isLoadingUserName ? "Loading..." : "Select User/Role"}
                </option>
                {!isLoadingUserName && userName.length > 0
                  ? userName.map((user) => (
                      <option key={user.userId} value={user.userId}>
                        {user?.name === "Customer" ? "LMBP" : user.name}
                      </option>
                    ))
                  : !isLoadingUserName && (
                      <option value="" disabled>
                        No data found
                      </option>
                    )}
              </select>
              {errorMessageName && (
                <div className="error-message">{errorMessageName}</div>
              )}
            </div>
          </div>

          <button
            className="menu-user-profile-search-btn"
            disabled={!selectedProfile || !selectedUser}
            style={{
              cursor:
                !selectedProfile || !selectedUser ? "not-allowed" : "pointer",
            }}
            onClick={handleSearchMenu}
          >
            Search
          </button>
        </div>
      </section>

      <section className="manage-team-members-section">
        <h2 className="menu-management-section-header">
          Manage Your Team members and their account permissions here
        </h2>
        {!userMenuData ? (
          <p
            className="text-start fw-bold"
            style={{
              marginTop: "7rem",
              marginBottom: "8rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            No items found
          </p>
        ) : (
          <>
            <div className="menu-card-container">
              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="User Master"
                isActive={activeController === "User Master"}
                onToggle={() => toggleController("User Master")}
                options={[
                  "Fetch",
                  "Create",
                  "Modify",
                  "Delete",
                  "Authorize",
                  "Audit Trial",
                  "Send Credentials",
                ]}
                toggleStatus={[
                  ...booleanArray.slice(1, 6),
                  booleanArray[54],
                  booleanArray[82],
                ]}
                onToggleChange={(index) =>
                  handleToggle(
                    index === 5 ? 54 : index === 7 ? 82 : 1 + index,
                    0
                  )
                }
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Vendor Master"
                isActive={activeController === "Vendor Master"}
                onToggle={() => toggleController("Vendor Master")}
                options={[
                  "Fetch",
                  "Create",
                  "Modify",
                  "Delete",
                  "Authorize",
                  "Audit Trail",
                ]}
                toggleStatus={[...booleanArray.slice(6, 11), booleanArray[55]]}
                onToggleChange={(index) =>
                  handleToggle(index === 5 ? 55 : 6 + index, 0)
                }
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="LMBP Master"
                isActive={activeController === "LMBP Master"}
                onToggle={() => toggleController("LMBP Master")}
                options={[
                  "Fetch",
                  "Create",
                  "Modify",
                  "Delete",
                  "Authorize",
                  "DLT",
                  "Audit Trail",
                ]}
                toggleStatus={[...booleanArray.slice(11, 17), booleanArray[56]]}
                onToggleChange={(index) =>
                  handleToggle(index === 6 ? 56 : 11 + index, 0)
                }
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Franchise Master"
                isActive={activeController === "Franchise Master"}
                onToggle={() => toggleController("Franchise Master")}
                options={[
                  "Fetch",
                  "Create",
                  "Modify",
                  "Delete",
                  "Authorize",
                  "DLT",
                  "Audit Trail",
                ]}
                toggleStatus={booleanArray.slice(116, 122)}
                onToggleChange={(index) => handleToggle(116, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Courier Hub"
                isActive={activeController === "Courier Hub"}
                onToggle={() => toggleController("Courier Hub")}
                options={[
                  "Fetch",
                  "Create",
                  "Modify",
                  "Delete",
                  "Authorize",
                  "DLT",
                  "Audit Trail",
                ]}
                toggleStatus={booleanArray.slice(88, 95)}
                onToggleChange={(index) => handleToggle(88, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Bag Master"
                isActive={activeController === "Bag Master"}
                onToggle={() => toggleController("Bag Master")}
                options={["Fetch", "Create", "Modify", "Delete", "Authorize"]}
                toggleStatus={booleanArray.slice(44, 49)}
                onToggleChange={(index) => handleToggle(44, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Bag Master (Courier Hub)"
                isActive={activeController === "Bag Master (Courier Hub)"}
                onToggle={() => toggleController("Bag Master (Courier Hub)")}
                options={["Fetch", "Create", "Modify", "Delete"]}
                toggleStatus={booleanArray.slice(49, 53)}
                onToggleChange={(index) => handleToggle(49, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Order Courier"
                isActive={activeController === "Order Courier"}
                onToggle={() => toggleController("Order Courier")}
                options={["Fetch"]}
                toggleStatus={booleanArray.slice(60, 61)}
                onToggleChange={(index) => handleToggle(60, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Transaction Controller"
                isActive={activeController === "Transaction Controller"}
                onToggle={() => toggleController("Transaction Controller")}
                options={[
                  "Purchase Credit details",
                  "Purchase Credits",
                  "API Document",
                  "Customer SMS Logs",
                  "Customer RCS Logs",
                ]}
                toggleStatus={booleanArray.slice(22, 27)} // Start from index 21 for Transaction
                onToggleChange={(index) => handleToggle(22, index)} // Adjust for base index 21
              />
              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Others"
                isActive={activeController === "Others"}
                onToggle={() => toggleController("Others")}
                options={["Menu Management", "Settings", "System SMS Logs"]}
                toggleStatus={booleanArray.slice(28, 31)}
                onToggleChange={(index) => handleToggle(28, index)}
              />
              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Role Controller"
                isActive={activeController === "Role Controller"}
                onToggle={() => toggleController("Role Controller")}
                options={["Fetch", "Create", "Modify", "Delete", "Authorize"]}
                toggleStatus={booleanArray.slice(31, 36)}
                onToggleChange={(index) => handleToggle(31, index)}
              />
              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Vendor transaction History"
                isActive={activeController === "Vendor transaction History"}
                onToggle={() => toggleController("Vendor transaction History")}
                options={["Fetch"]}
                toggleStatus={booleanArray.slice(41, 42)}
                onToggleChange={(index) => handleToggle(41, index)}
              />
              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Bulk SMS"
                isActive={activeController === "Bulk SMS"}
                onToggle={() => toggleController("Bulk SMS")}
                options={["Fetch", "Create"]}
                toggleStatus={booleanArray.slice(42, 44)}
                onToggleChange={(index) => handleToggle(42, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Top-Up SMS/RCS"
                isActive={activeController === "Top-Up SMS/RCS"}
                onToggle={() => toggleController("Top-Up SMS/RCS")}
                options={["Fetch", "Create", "Checker", "Delete", "Authorize"]}
                toggleStatus={booleanArray.slice(44, 49)}
                onToggleChange={(index) => handleToggle(44, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Main Wallet"
                isActive={activeController === "Main Wallet"}
                onToggle={() => toggleController("Main Wallet")}
                options={[
                  "Fetch",
                  "Create",
                  "Modify",
                  "Delete",
                  "Authorize",
                  "Audit Trail",
                  "DLT",
                  "Checker",
                ]}
                // toggleStatus={booleanArray.slice(49, 54)}
                toggleStatus={[
                  booleanArray[49], // Fetch
                  booleanArray[50], // Create
                  booleanArray[57], // Modify (custom index)
                  booleanArray[53], // Delete
                  booleanArray[51], // Authorize
                  booleanArray[52], // Audit Trail
                  booleanArray[58], // DLT
                  booleanArray[59], // Checker
                ]}
                onToggleChange={(index) => {
                  const mapping = [49, 50, 57, 53, 51, 52, 58, 59];
                  handleToggle(mapping[index], 0);
                }}
                // onToggleChange={(index) => handleToggle(49, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Recharge/BBPS"
                isActive={activeController === "Recharge/BBPS"}
                onToggle={() => toggleController("Recharge/BBPS")}
                options={["Fetch"]}
                toggleStatus={booleanArray.slice(60, 61)}
                onToggleChange={(index) => handleToggle(60, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Courier Master"
                isActive={activeController === "Courier Master"}
                onToggle={() => toggleController("Courier Master")}
                options={[
                  "Fetch",
                  "Create",
                  "Modify",
                  "Delete",
                  "Authorize",
                  "Checker",
                ]}
                toggleStatus={[...booleanArray.slice(61, 66), booleanArray[75]]}
                onToggleChange={(index) =>
                  handleToggle(index === 5 ? 75 : 61 + index, 0)
                }
              />
              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Order Master"
                isActive={activeController === "Order Master"}
                onToggle={() => toggleController("Order Master")}
                options={["Fetch", "Create", "Modify"]}
                toggleStatus={[
                  ...booleanArray.slice(66, 67),
                  booleanArray[83],
                  booleanArray[84],
                ]}
                // onToggleChange={(index) => handleToggle(66, index)}
                onToggleChange={(index) =>
                  handleToggle(index === 1 ? 83 : index === 2 ? 84 : 66, 0)
                }
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Ledger"
                isActive={activeController === "Ledger"}
                onToggle={() => toggleController("Ledger")}
                options={["Fetch"]}
                toggleStatus={booleanArray.slice(67, 68)}
                onToggleChange={(index) => handleToggle(67, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="RCS Master"
                isActive={activeController === "RCS Standalone Msg"}
                onToggle={() => toggleController("RCS Standalone Msg")}
                options={[
                  "RCS Standalone Msg",
                  "RCS Plain Text",
                  "RCS Carousel",
                ]}
                toggleStatus={booleanArray.slice(68, 71)}
                onToggleChange={(index) => handleToggle(68 + index, 0)}
              />
              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Customer Enquiries"
                isActive={activeController === "Customer Enquiries"}
                onToggle={() => toggleController("Customer Enquiries")}
                options={["Fetch"]}
                toggleStatus={booleanArray.slice(75, 76)}
                onToggleChange={(index) => handleToggle(75, index)}
              />
              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Pickup Address"
                isActive={activeController === "Pickup Address"}
                onToggle={() => toggleController("Pickup Address")}
                options={["Fetch", "Create", "Modify"]}
                toggleStatus={booleanArray.slice(77, 81)}
                onToggleChange={(index) => handleToggle(77, index)}
              />
              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Notification Master"
                isActive={activeController === "Notification Master"}
                onToggle={() => toggleController("Notification Master")}
                options={["Fetch"]}
                toggleStatus={[booleanArray[86]]}
                onToggleChange={(index) => handleToggle(86, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Notification Master (Courier Hub)"
                isActive={
                  activeController === "Notification Master (Courier Hub)"
                }
                onToggle={() =>
                  toggleController("Notification Master (Courier Hub)")
                }
                options={["Fetch"]}
                toggleStatus={[booleanArray[87]]}
                onToggleChange={(index) => handleToggle(87, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Rate Card Master"
                isActive={activeController === "Rate Card Master"}
                onToggle={() => toggleController("Rate Card Master")}
                options={["Fetch", "Create", "Modify"]}
                toggleStatus={booleanArray.slice(139, 142)}
                onToggleChange={(index) => handleToggle(139, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Charge Master"
                isActive={activeController === "Charge Master"}
                onToggle={() => toggleController("Charge Master")}
                options={["Fetch", "Create", "Modify", "Delete", "Authorize"]}
                toggleStatus={booleanArray.slice(95, 100)}
                onToggleChange={(index) => handleToggle(95, index)}
              />
              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Pincode Serviceability"
                isActive={activeController === "Pincode Serviceability"}
                onToggle={() => toggleController("Pincode Serviceability")}
                options={["Fetch", "Create", "Modify", "Delete", "Authorize"]}
                toggleStatus={booleanArray.slice(100, 105)}
                onToggleChange={(index) => handleToggle(100, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Rate Calculator"
                isActive={activeController === "Rate Calculator"}
                onToggle={() => toggleController("Rate Calculator")}
                options={["Fetch", "Create", "Modify", "Delete", "Authorize"]}
                toggleStatus={booleanArray.slice(105, 110)}
                onToggleChange={(index) => handleToggle(105, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="LMBP Rate Calculator"
                isActive={activeController === "LMBP Rate Calculator"}
                onToggle={() => toggleController("LMBP Rate Calculator")}
                options={[
                  "LMBP Rate Calculator",
                ]}
                toggleStatus={booleanArray.slice(127, 128)}
                onToggleChange={(index) => handleToggle(127, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Delivery Master"
                isActive={activeController === "Delivery Master"}
                onToggle={() => toggleController("Delivery Master")}
                options={["Fetch", "Create", "Modify", "Delete", "Authorize"]}
                toggleStatus={booleanArray.slice(110, 115)}
                onToggleChange={(index) => handleToggle(110, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Generate Sticker"
                isActive={activeController === "Generate Sticker"}
                onToggle={() => toggleController("Generate Sticker")}
                options={["Fetch", "Create"]}
                toggleStatus={booleanArray.slice(123, 125)}
                onToggleChange={(index) => handleToggle(123, index)}
              />
              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Track Order"
                isActive={activeController === "Track Order"}
                onToggle={() => toggleController("Track Order")}
                options={[
                  "Track Order",
                ]}
                toggleStatus={booleanArray.slice(125, 126)}
                onToggleChange={(index) => handleToggle(125, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Statement"
                isActive={activeController === "Statement"}
                onToggle={() => toggleController("Statement")}
                options={[
                  "Statement",
                ]}
                toggleStatus={booleanArray.slice(126, 127)}
                onToggleChange={(index) => handleToggle(126, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Stationary Master"
                isActive={activeController === "Stationary Master"}
                onToggle={() => toggleController("Stationary Master")}
                options={["Fetch", "Create", "Modify"]}
                toggleStatus={booleanArray.slice(128, 131)}
                onToggleChange={(index) => handleToggle(128, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Buy Stationary"
                isActive={activeController === "Buy Stationary"}
                onToggle={() => toggleController("Buy Stationary")}
                options={["Fetch", "Create", "Modify"]}
                toggleStatus={booleanArray.slice(131, 134)}
                onToggleChange={(index) => handleToggle(131, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Top Up Wallet"
                isActive={activeController === "Top Up Wallet"}
                onToggle={() => toggleController("Top Up Wallet")}
                options={["Fetch"]}
                toggleStatus={booleanArray.slice(134, 135)}
                onToggleChange={(index) => handleToggle(134, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Upload Card RAW File"
                isActive={activeController === "Upload Card RAW File"}
                onToggle={() => toggleController("Upload Card RAW File")}
                options={["Fetch", "Create"]}
                toggleStatus={booleanArray.slice(135, 137)}
                onToggleChange={(index) => handleToggle(135, index)}
              />

              <MenuCard
                disabled={!isAuthorizedAdmin()}
                title="Payment History"
                isActive={activeController === "Payment History"}
                onToggle={() => toggleController("Payment History")}
                options={["Fetch"]}
                // toggleStatus={booleanArray.slice(137, 138)}
                toggleStatus={[booleanArray[138]]}
                onToggleChange={(index) => handleToggle(138, index)}
              />
              
            </div>
            <div className="submit-container">
              <button
                className="submit-btn"
                onClick={modifyMenuManagementData}
                disabled={!isAuthorizedAdmin()}
                style={{
                  cursor: !isAuthorizedAdmin() ? "not-allowed" : "pointer",
                  opacity: !isAuthorizedAdmin() ? 0.6 : 1,
                }}
              >
                Submit
              </button>
            </div>
          </>
        )}
      </section>
    </div>
  );
};

export default MenuManagement;
//Last Used 54-142
